exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host {\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%); }\n  :host .container {\n    width: 100%;\n    height: 100%;\n    padding-top: 2px;\n    padding-right: 2px;\n    padding-bottom: 2px;\n    padding-left: 2px; }\n  :host .valid {\n    color: #00BBA6; }\n  :host .invalid {\n    color: #FF544D; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/widgets/explorer/components/item-state/item-state.component.scss
// module id = ../../../../../src/app/modules/widgets/explorer/components/item-state/item-state.component.scss
// module chunks = main